import { useCallback, useEffect, useState } from "react";
import { getSurveySubmission, getSurveySubmissions } from "api/survey/surveyApi";
import { apiErrorMessage, paginatorFromResponse } from "api/survey/surveyApi.utils";

const emptyPagination = { rows: [], currentPage: 1, lastPage: 1, perPage: 15, total: 0, from: 0, to: 0 };

export default function useSurveySubmissions({ surveyId, enabled, notify }) {
  const [submissions, setSubmissions] = useState(emptyPagination);
  const [submissionDetail, setSubmissionDetail] = useState(null);
  const [submissionsLoading, setSubmissionsLoading] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);

  const loadSubmissions = useCallback(async (page = 1) => {
    if (!surveyId) return;
    setSubmissionsLoading(true);
    try {
      setSubmissions(paginatorFromResponse(await getSurveySubmissions(surveyId, page)));
    } catch (error) {
      notify(apiErrorMessage(error, "Unable to load survey submissions."), "error");
    } finally {
      setSubmissionsLoading(false);
    }
  }, [notify, surveyId]);

  useEffect(() => {
    if (enabled) loadSubmissions(1);
  }, [enabled, loadSubmissions]);

  const openSubmission = async (submission) => {
    setDetailLoading(true);
    try {
      const response = await getSurveySubmission(surveyId, submission.id);
      setSubmissionDetail(response.data);
    } catch (error) {
      notify(apiErrorMessage(error, "Unable to load submission details."), "error");
    } finally {
      setDetailLoading(false);
    }
  };

  return { submissions, submissionDetail, setSubmissionDetail, submissionsLoading, detailLoading, loadSubmissions, openSubmission };
}
